var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    rx: 2,
    fill: "#EBEBEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.47656,
    y: 2.66797,
    width: 8.36,
    height: 8.36,
    rx: 2,
    fill: "#929292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59461 4.63672C4.33203 4.63672 4.11719 4.85439 4.11719 5.12043V8.02266C4.11719 8.2887 4.33203 8.50637 4.59461 8.50637H7.10109C7.03616 8.35259 6.99587 8.1893 6.98173 8.02266H4.59461V5.60413L6.50431 6.8134L8.41401 5.60413V6.32969C8.45378 6.32814 8.49359 6.32814 8.53336 6.32969C8.65398 6.33005 8.77415 6.34466 8.89143 6.37322V5.12043C8.89143 4.85439 8.67659 4.63672 8.41401 4.63672H4.59461ZM4.59461 5.12043H8.41401L6.50431 6.32969L4.59461 5.12043ZM8.41401 6.57154L7.8769 7.11571L8.41401 7.65988V7.2971C8.57228 7.2971 8.72408 7.36081 8.836 7.4742C8.94791 7.58759 9.01079 7.74138 9.01079 7.90174C9.01079 7.99848 8.9893 8.09038 8.94872 8.17261L9.20892 8.43623C9.30918 8.28386 9.36886 8.10006 9.36886 7.90174C9.36886 7.36724 8.94156 6.93432 8.41401 6.93432V6.57154ZM7.6191 7.36724C7.51884 7.51961 7.45916 7.70342 7.45916 7.90174C7.45916 8.43623 7.88645 8.86915 8.41401 8.86915V9.23193L8.95111 8.68776L8.41401 8.14359V8.50637C8.25573 8.50637 8.10394 8.44267 7.99202 8.32928C7.8801 8.21589 7.81723 8.0621 7.81723 7.90174C7.81723 7.805 7.83871 7.71309 7.87929 7.63086L7.6191 7.36724V7.36724Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.82c21ffdf5bbc6ac89d8ae7126a04971.svg";
export { ForwardRef as ReactComponent };